import { Container, Link, Picture, Text } from '@doist/marketist'

import { Interpolate } from 'components'
import { useTranslation } from 'next-i18next'

import { appendSlackAltUTM } from '../appendSlackAlternativeUTM'

import css from './MadeByDoist.module.css'

export function MadeByDoist() {
    const { t } = useTranslation('slackalternative')

    return (
        <Container className={css.madeByDoistContainer}>
            <Text className={css.title} tag="h3" size="major-2xl">
                {t('madeByDoist')}
            </Text>
            <Picture
                width={327}
                height={279}
                path="/assets/slack-alternative/made-by-doist/made-by-doist-"
                sizes={[327, 577, 790, 958, 1004]}
                loading="lazy"
                className={css.illustration}
            />
            <div className={css.copy}>
                <Text tag="h4" size="major-sm" className={css.subTitle}>
                    {t('pioneers')}
                </Text>
                <Text size="body-base" className={css.body}>
                    <Interpolate
                        t={t}
                        i18nKey="pioneersBody"
                        mapping={{
                            link: (
                                <Link
                                    href={appendSlackAltUTM(
                                        'https://blog.doist.com/betting-against-slack/',
                                    )}
                                />
                            ),
                        }}
                    />
                </Text>
                <Text tag="h4" size="major-sm" className={css.subTitle}>
                    {t('fullyRemote')}
                </Text>
                <Text size="body-base">{t('fullyRemoteBody')}</Text>
            </div>
        </Container>
    )
}
